// jQuery
global.jQuery = require('jquery');
global.$ = global.jQuery;

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};


$(function () {

    let app = require('./modules/core')();
    app.initBootstrap();
    app.initLazyLoad();
    app.initLightbox();
    app.initSlickCarousel();
    app.scrollToAnchor();
    app.scrollToAccordionItem();
    app.detectUrlScrollHash();
    app.convertCryptedEmails();
    app.initMobileMenu();
    app.initRrssb();
    app.initPopups();

    //app.navDropdownHover(); // Hover instead of click on Nav dropdowns
    //app.initDatePicker();
    app.initWowJs();
    app.initStickyEl();
    //app.initTooltips();
    app.announcementBarDismiss();
    app.cartInit();
    app.backToTop();

    // let googleMaps = require('./modules/google-maps')();
    // googleMaps.assign();


    $(".megamenu").on("click", function(e) {
        e.stopPropagation();
    });

    const cards = document.querySelectorAll(".card");
    cards.forEach((c) => {
        c.addEventListener("click", () => {
            removeactive();
            c.classList.add("active");
        });
    });

    function removeactive() {
        cards.forEach((c) => {
            c.classList.remove("active");
            //c.classList.add("remove");
        });
    }


    // Fixes issue with active class not removing when using inside slick slider
    $(".nav-pills .nav-link").click(function() {
        $(".nav-pills .nav-link").removeClass('active');
    });

    $(".nav-link").on("shown.bs.tab", function (e) {
        var href = $(this).attr("data-target");
        $("html, body").animate(
            {
                scrollTop: $(href).offset().top -150
            },
            "slow"
        );
    });



});
